require('frontend-controller/client/utils');

// init vendor styles
require('gsap/TweenMax');
require('gsap/Draggable');

// init custom styles
require('./styles/index.less');

// init config
require('frontend-controller/client/config').setConfig(
    require('./clientAppConfig'),
    {
        templates:  require.context('./components/', true, /^\.\/(?!mails\/).*\.ejs$/),
        components: require.context('./components/', true, /^\.\/(?!mails\/).*\.js$/),
        styles:     require.context('./components/', true, /^\.\/(?!mails\/).*\.less$/)
    }
);

// init
require('frontend-controller/client/app');

// init owlCarousel
require('./vendor/owlCarousel/owl.carousel.css');       // minified: 1 KB
require('./vendor/owlCarousel/owl.theme.css');          // minified: 1 KB
require('./vendor/owlCarousel/owl.carousel.min.js');    // minified: 24 KB
